import { elemSiblings } from "./support";

export const INIT_tabs = () => {
    window.addEventListener('click', event => {
        const trigger = event.target;

        if (trigger.hasAttribute('grit-tabs-trigger')) {
            const tabs = trigger.closest('[grit-tabs]');
            const tab = document.getElementById(trigger.getAttribute('grit-tabs-trigger'));
            const tabSiblings = elemSiblings(tab);

            if (tabs) {
                const tabsNav = [...tabs.querySelectorAll('[grit-tabs-trigger]')];

                if (tabsNav) {
                    tabsNav.forEach(navItem => {
                        if (navItem === trigger) {
                            navItem.classList.add('is-active');
                        } else {
                            navItem.classList.remove('is-active');
                        }
                    });
                }

                if (tab && tabSiblings) {
                    tab.classList.add('is-active');

                    tabSiblings.forEach(sibling => {
                        sibling.classList.remove('is-active');
                    });
                }
            }
        }
    });
};
